import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQ = [
  { q: "Do I need to install anything?", a: "No. Cricket Graphics Studio runs 100% in your browser. Sign in on any laptop and you're ready to score and stream." },
  { q: "Does it work with vMix and OBS?", a: "Yes. Paste your unique overlay URL into vMix or OBS as a Browser Source (1920×1080). The graphic is on a fully transparent layer — no chroma-key needed." },
  { q: "How fast do updates reach my stream?", a: "Under 200 milliseconds. When you click a run, wicket, or theme switch on the controller, it appears on your live broadcast almost instantly via Firebase realtime sync." },
  { q: "Can I switch themes during a live match?", a: "Yes — one click. Every theme has a live preview thumbnail so you can safely see how the switch will look before pushing it on-air." },
  { q: "What happens after my subscription expires?", a: "You'll be unable to log in until you extend. WhatsApp us and we'll renew you in under 5 minutes." },
  { q: "Is there a refund policy?", a: "Yes — if the software doesn't work for you during your first match, we refund 100%. No questions asked." },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-20 max-w-3xl mx-auto px-6">
      <div className="text-center mb-10">
        <h2 className="font-heading text-4xl md:text-5xl font-black uppercase">Questions?</h2>
      </div>
      <div className="space-y-3">
        {FAQ.map((f, i) => (
          <div key={f.q} className="rounded-xl bg-slate-800/50 border border-slate-700 overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              data-testid={`faq-toggle-${i}`}
              className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-slate-800/70">
              <span className="font-semibold text-white">{f.q}</span>
              <ChevronDown size={18} className={`text-slate-400 transition ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && (
              <div className="px-5 pb-4 text-slate-300 text-sm leading-relaxed border-t border-slate-800 pt-3">{f.a}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
